export const CloseSearchSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.0001 4.99985C14.8438 4.84362 14.6319 4.75586 14.4109 4.75586C14.19 4.75586 13.978 4.84362 13.8218 4.99985L10.0001 8.82152L6.17843 4.99985C6.02215 4.84362 5.81023 4.75586 5.58926 4.75586C5.36829 4.75586 5.15637 4.84362 5.00009 4.99985C4.84387 5.15612 4.7561 5.36804 4.7561 5.58901C4.7561 5.80998 4.84387 6.02191 5.00009 6.17818L8.82176 9.99985L5.00009 13.8215C4.84387 13.9778 4.7561 14.1897 4.7561 14.4107C4.7561 14.6317 4.84387 14.8436 5.00009 14.9998C5.15637 15.1561 5.36829 15.2438 5.58926 15.2438C5.81023 15.2438 6.02215 15.1561 6.17843 14.9998L10.0001 11.1782L13.8218 14.9998C13.978 15.1561 14.19 15.2438 14.4109 15.2438C14.6319 15.2438 14.8438 15.1561 15.0001 14.9998C15.1563 14.8436 15.2441 14.6317 15.2441 14.4107C15.2441 14.1897 15.1563 13.9778 15.0001 13.8215L11.1784 9.99985L15.0001 6.17818C15.1563 6.02191 15.2441 5.80998 15.2441 5.58901C15.2441 5.36804 15.1563 5.15612 15.0001 4.99985Z"
        fill="#6C757D"
      />
    </svg>
  );
};
